class PreorderInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input")
    this.preorderNotification = this.querySelector(".product__preorder-msg");
  }

  showMessage(msg) {
    this.input.value = msg;
    this.input.removeAttribute("disabled");

    if (this.dataset.productTitle) {
      this.preorderNotification.innerHTML = `
        <span class="product__preorder-msg__first-item-phrase">
          ${msg
            .replace(
              "This is a Limited Pre-Order",
              "Some items in this set are on Pre-Order"
            )
            .replace("Orders", this.dataset.productTitle)}
        </span>
        <span class="product__preorder-msg__next-item-phrase">
          ${msg.replace(
            "This is a Limited Pre-Order. Orders will land in our warehouse &",
            `${this.dataset.productTitle} will`
          )}
        </span>
      `;
    } else {
      this.preorderNotification.textContent = msg;
    }
  }

  hideMessage() {
    this.input.setAttribute("disabled", "disabled");
  }
}

customElements.define("preorder-input", PreorderInput);

/*
const productContainers = document.querySelector('.product-grid');

productContainers.addEventListener('click', (event) => {
  let target = event.target;
  while (target != productContainers) {
    if (target.tagName == 'LABEL') {
      const input = target.querySelector('input');
      if (input && input.disabled) {
        target.setAttribute('disabled', '');
      } else {
        target.removeAttribute('disabled');
      }
      if (!input.disabled) {
        // Remove the 'clicked' class from all labels in the current product container
        const labels = target.closest('.product-card').querySelectorAll('.slider-item__variants label');
        labels.forEach((l) => l.classList.remove('clicked'));

        // Add the 'clicked' class to the clicked label
        target.classList.add('clicked');
      }
      return; // Stop the loop after handling the click
    }
    target = target.parentNode; // Go up in the DOM
  }
}); */

document.addEventListener('click', (event) => {
  const productContainers = document.querySelector('.product-grid');
  let target = event.target;

  // Check if clicked element is inside productContainers
  if (!productContainers || !productContainers.contains(target)) return;

  while (target != productContainers) {
    if (target.tagName == 'LABEL') {
      const input = target.querySelector('input');
      if (input && input.disabled) {
        target.setAttribute('disabled', '');
      } else {
        target.removeAttribute('disabled');
      }
      if (!input.disabled) {
        // Remove the 'clicked' class from all labels in the current product container
        const labels = target.closest('.product-card').querySelectorAll('.slider-item__variants label');
        labels.forEach((l) => l.classList.remove('clicked'));

        // Add the 'clicked' class to the clicked label
        target.classList.add('clicked');
      }
      return; // Stop the loop after handling the click
    }
    target = target.parentNode; // Go up in the DOM
  }
});

